import { FormFieldDefinition } from '../../../../../../generic/universal-table/types/form.types'
import { PalletUiRow } from '../types/palletTable.types'

export const palletTableFormFields: FormFieldDefinition<PalletUiRow>[] = [
  {
    name: 'Pallete_Desc',
    label: 'תיאור משטח',
    inputType: 'text',
    required: true,
    placeholder: 'הזן תיאור',
    validationRules: {
      required: true,
      minLength: 1,
      maxLength: 100,
    },
  },
  {
    // getOptions is injected in PalletTableModule.tsx
    name: 'SupplierID',
    label: 'ספק',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in PalletTableModule.tsx
    name: 'Main_PalleteID',
    label: 'משטח ראשי',
    inputType: 'searchable-select',
    required: false,
  },
  {
    // getOptions is injected in PalletTableModule.tsx
    name: 'Accessory1',
    label: 'אביזר 1',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'Accessory2',
    label: 'אביזר 2',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'Accessory3',
    label: 'אביזר 3',
    inputType: 'searchable-select',
    required: false,
  },
  {
    name: 'Catalog_Number',
    label: 'מספר קטלוגי',
    inputType: 'text',
    required: false,
    placeholder: 'מספר קטלוגי',
    validationRules: {
      maxLength: 50,
    },
  },
  {
    name: 'Pallete_Price',
    label: 'מחיר',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Real_Pallete',
    label: 'משטח ממשי',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Tare_Weight',
    label: 'משקל טרה',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Cooling_Fee',
    label: 'דמי קירור',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Usage_Fee',
    label: 'דמי שימוש',
    inputType: 'number',
    required: false,
    defaultValue: 0,
    validationRules: { min: 0 },
  },
  {
    name: 'Active',
    label: 'פעיל',
    inputType: 'boolean-select',
    required: false,
    defaultValue: true,
  },
  {
    name: 'DepositWithVAT',
    label: 'פיקדון כולל מעמ',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Download_from_Warehouse',
    label: 'פריקה ממחסן',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Growers_Pallete',
    label: 'משטח גדלים',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Inventory',
    label: 'מלאי',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Transportation_Fee',
    label: 'דמי הובלה',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
  {
    name: 'Tranzit_Fee',
    label: 'דמי מעבר',
    inputType: 'boolean-select',
    required: false,
    defaultValue: false,
  },
]
